/**
 * HI invoice page loads via GET /home-inspection/work-orders/{workOrderId}/invoice.
 * Callers must always pass workOrderId; the path :id is the invoice number (display/validation only).
 */
export const buildHiInvoicePath = (
  invoiceNumber: string,
  workOrderId: string,
  workOrderNumber?: string
): string => {
  const params = new URLSearchParams({ workOrderId });
  if (workOrderNumber) {
    params.set('workOrderNumber', workOrderNumber);
  }
  return `/home-inspection/invoice/${encodeURIComponent(invoiceNumber)}?${params.toString()}`;
};
